import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Loader2, MailCheck } from "lucide-react";
import { AuthShell, Field } from "@/pages/Login";

const inputCls = "w-full bg-navy border border-white/20 text-white p-3 focus:border-gold focus:outline-none";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthShell title="Check your inbox" subtitle="If an account exists for that email, a reset link is on its way.">
        <div className="flex flex-col items-center text-center" data-testid="forgot-success">
          <div className="w-14 h-14 border border-gold/40 flex items-center justify-center text-gold mb-6"><MailCheck size={26} /></div>
          <p className="text-gray-400 mb-8">The link expires in 60 minutes. Be sure to check your spam folder if you don't see it.</p>
          <Link to="/login" className="text-gold hover:underline" data-testid="back-to-login">Back to sign in</Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Reset your password" subtitle="Enter your email and we'll send you a reset link.">
      <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
        {error && <div className="bg-destructive/15 border border-destructive/40 text-red-300 text-sm px-4 py-3" data-testid="forgot-error">{error}</div>}
        <Field label="Email">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="forgot-email" className={inputCls} placeholder="you@company.com" />
        </Field>
        <button type="submit" disabled={loading} data-testid="forgot-submit"
          className="w-full bg-gold text-navy py-4 font-semibold hover:bg-gold-light transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
          {loading && <Loader2 className="animate-spin" size={18} />} Send reset link
        </button>
      </form>
      <p className="text-center text-gray-400 text-sm mt-6">
        Remembered it? <Link to="/login" className="text-gold hover:underline" data-testid="go-login">Sign in</Link>
      </p>
    </AuthShell>
  );
}
